module.exports = __webpack_public_path__ + "img/iot_patients.a7f48daf.svg";